// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2MSzW","modal":"Modal_modal__2eQPZ","body":"Modal_body__3KKW4"};